import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { 
    Box, 
    Divider, 
    Drawer, 
    useMediaQuery, 
    List, 
    Collapse, 
    ListItemButton, 
    ListItemIcon, 
    ListItemText 
} from "@mui/material";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import Person2Icon from "@mui/icons-material/Person2";
import { ChartBar as ChartBarIcon } from "../icons/chart-bar";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import CasinoIcon from "@mui/icons-material/Casino";
import TuneIcon from "@mui/icons-material/Tune";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import PaidIcon from "@mui/icons-material/Paid";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import SettingsIcon from "@mui/icons-material/Settings";
import ApiIcon from "@mui/icons-material/Api";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import CachedIcon from "@mui/icons-material/Cached";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import ChatIcon from "@mui/icons-material/Chat";
import { useEffect, useState } from "react";
import { Logo } from "./logo";
import { NavItem } from "./nav-item";
import { Users } from "../icons/users";
import { t } from "i18next";
import { isFeatureEnabled } from "../utils/serverFeatures";

export const DashboardSidebar = (props) => {
    const [openMenus, setOpenMenus] = useState({});

    const handleMenuToggle = (title) => {
        setOpenMenus((prev) => ({
            ...prev,
            [title]: !prev[title]
        }));
    };
    const getSanhList = (basePath) => {
        return [1, 2, 3, 4, 5, 6].map((num) => ({
            href: `${basePath}${num}`, 
            icon: <SportsEsportsIcon fontSize="small" />, 
            title: `Sảnh ${num}`
        }));
    };

    const items = [
        {
            href: "/agency",
            icon: <ChartBarIcon fontSize="small" />,
            title: "Báo cáo đại lý"
        },
        {
            href: "/agency/users",
            icon: <Person2Icon fontSize="small" />,
            title: "Danh sách Hội viên"
        },
        {
            href: "/agency/deposit",
            icon: <PaidIcon fontSize="small" />,
            title: "Lịch sử nạp tiền"
        },
        {
            href: "/agency/withdraw",
            icon: <CurrencyExchangeIcon fontSize="small" />,
            title: "Lịch sử rút tiền"
        },
        {
            href: "/agency/history",
            icon: <SportsEsportsIcon fontSize="small" />,
            title: "Lịch sử đặt cược"
        },
        {
            href: "/agency/refund",
            icon: <CachedIcon fontSize="small" />,
            title: "Lịch sử hoàn trả"
        },
        {
            href: "/agency/giftcode",
            icon: <RocketLaunchIcon fontSize="small" />,
            title: "Phát Lì Xì"
        },

    ];

    const subItems = [
        {
            href: "/admin",
            icon: <ChartBarIcon fontSize="small" />,
            title: t('statistical')
        },
        {
            href: "/admin/users",
            icon: <Person2Icon fontSize="small" />,
            title: t('users')
        },
        {
            href: "/admin/add",
            icon: <PaidIcon fontSize="small" />,
            title: t('recharge')
        },
        {
            href: "/admin/request",
            icon: <CurrencyExchangeIcon fontSize="small" />,
            title: t('withdraw')
        },
        {
            href: "/admin/khuyenmai",
            icon: <RocketLaunchIcon fontSize="small" />,
            title: "Phát Lì Xì"
        },
        {
            href: "/admin/history",
            icon: <SportsEsportsIcon fontSize="small" />,
            title: t('history_play')
        },
        {
            href: "/admin/historyapi",
            icon: <ApiIcon fontSize="small" />,
            title: "Lịch sử API (Casino)"
        },
        {
            href: "/admin/refund",
            icon: <CachedIcon fontSize="small" />,
            title: t('history_refund')
        }
    ];

    if (isFeatureEnabled("onlineUsers")) {
        items.splice(2, 0, {
            href: "/admin/online-users",
            icon: <Users fontSize="small" />,
            title: "User Online"
        });
        subItems.splice(2, 0, {
            href: "/admin/online-users",
            icon: <Users fontSize="small" />,
            title: "User Online"
        });
    }

    if (isFeatureEnabled("cleanup")) {
        items.push({
            href: "/admin/cleanup",
            icon: <DeleteSweepIcon fontSize="small" />,
            title: "Dọn dẹp dữ liệu"
        });
    }

    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"), {
        defaultMatches: true,
        noSsr: false
    });

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (props.open == true) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [props.open]);

    const sendData = () => {
        props.callback(false);
    };

    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));

    useEffect(() => {
        const timer = setInterval(() => {
            const storedProfile = JSON.parse(localStorage.getItem("profile"));
            if (storedProfile && (profile === undefined || profile === null)) {
                setProfile(storedProfile);
            } else {
                clearInterval(timer);
            }
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, [profile]);

    const content = (
        <>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%"
                }}
                className="admin-theme">
                <div>
                    <Box sx={{ p: 3 }}>
                        <Link
                            to="/"
                            style={{
                                textDecoration: "none",
                                alignItems: "center",
                                display: "flex"
                            }}>
                            <Logo
                                sx={{
                                    height: 42,
                                    width: 42
                                }}
                            />

                        </Link>
                    </Box>
                </div>
                <Divider
                    sx={{
                        borderColor: "rgba(255,255,255,0.2)",
                        my: 0
                    }}
                />
                <Box sx={{ flexGrow: 1, p: 0, overflowY: "auto" }}>
                        <List component="nav" sx={{ pt: 2 }}>
                            {items.map((item) => {
                                // Nếu có children thì hiển thị menu cha có Dropdown
                                if (item.children) {
                                    const isItemOpen = openMenus[item.title] || false;

                                    return (
                                        <Box key={item.title}>
                                            <ListItemButton
                                                onClick={() => handleMenuToggle(item.title)}
                                                sx={{
                                                    borderRadius: 1,
                                                    color: "#FFFFFF",
                                                    justifyContent: "flex-start",
                                                    px: 3,
                                                    py: 1.5,
                                                    textAlign: "left",
                                                    textTransform: "none",
                                                    width: "100%",
                                                    "&:hover": {
                                                        backgroundColor: "rgba(255,255,255, 0.12)"
                                                    }
                                                }}>
                                                <ListItemIcon sx={{ color: "#FFFFFF", minWidth: 36 }}>
                                                    {item.icon}
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={item.title}
                                                    primaryTypographyProps={{ fontSize: "14px", fontWeight: 600, color: "#FFFFFF" }}
                                                />
                                                {isItemOpen ? (
                                                    <ExpandLess sx={{ color: "#FFFFFF" }} />
                                                ) : (
                                                    <ExpandMore sx={{ color: "#FFFFFF" }} />
                                                )}
                                            </ListItemButton>

                                            <Collapse in={isItemOpen} timeout="auto" unmountOnExit>
                                                <List component="div" disablePadding sx={{ pl: 2 }}>
                                                    {item.children.map((child) => (
                                                        <NavItem
                                                            key={child.title}
                                                            icon={child.icon}
                                                            to={child.href}
                                                            title={child.title}
                                                        />
                                                    ))}
                                                </List>
                                            </Collapse>
                                        </Box>
                                    );
                                }

                                // Nếu KHÔNG có children thì dùng NavItem bình thường
                                return <NavItem key={item.title} icon={item.icon} to={item.href} title={item.title} />;
                            })}
                        </List>
                </Box>
                <Divider sx={{ borderColor: "rgba(255,255,255,0.2)" }} />
                <Box sx={{ px: 2, py: 3 }}></Box>
            </Box>
        </>
    );

    if (lgUp) {
        return (
            <Drawer
                anchor="left"
                open={open}
                PaperProps={{
                    sx: {
                        backgroundColor: "#111827",
                        color: "#FFFFFF",
                        width: 250
                    }
                }}
                variant="permanent">
                {content}
            </Drawer>
        );
    }
    return (
        <Drawer
            anchor="left"
            onClose={sendData}
            open={open}
            PaperProps={{
                sx: {
                    backgroundColor: "#111827",
                    color: "#FFFFFF",
                    width: 250
                }
            }}
            sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
            variant="temporary">
            {content}
        </Drawer>
    );
};